import { ICONS } from 'components/Icons';
import { CoverType, Extra } from 'scenes/common/types';
import { OptionalExtra } from 'scenes/home/types';
import {
  fusionBuilding as fusionBuildingContent,
  fusionContents as fusionContentsContent,
  accidentalDamage as accidentalDamageContent,
} from './OptionalExtrasContent';

const accidentalDamage = {
  code: OptionalExtra.AccidentalDamage,
  label: 'Accidental damage',
  summaryLabel: 'Accidental damage',
  image: ICONS.OPTIONAL_EXTRA.HOME.ACCIDENTAL_DAMAGE,
  content: accidentalDamageContent,
};
const fusionBuilding = {
  code: OptionalExtra.FusionBuilding,
  label: 'Motor burn out cover for Building',
  summaryLabel: 'Motor burn out - Building',
  image: ICONS.OPTIONAL_EXTRA.HOME.FUSION_BUILDING,
  content: fusionBuildingContent,
};
const fusionContents = {
  code: OptionalExtra.FusionContent,
  label: 'Motor burn out cover for Contents',
  summaryLabel: 'Motor burn out - Contents',
  image: ICONS.OPTIONAL_EXTRA.HOME.FUSION_CONTENTS,
  content: fusionContentsContent,
};

export const availableExtras: {
  [key in CoverType]: Extra[];
} = {
  [CoverType.Building]: [fusionBuilding],
  [CoverType.BuildingAndContents]: [
    accidentalDamage,
    fusionBuilding,
    fusionContents,
  ],
  [CoverType.Contents]: [fusionContents, accidentalDamage],
  [CoverType.Unspecified]: [],
};
